// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2TWI_","productName":"Table_productName__1V0nX"};